<template>
  <div class="course-group-page">
    <div class="filter">
      <a-row :gutter="8">
        <a-col :span="3">
          <a-select
            class="select-item"
            v-model="searchParams.gradeId"
            allow-clear
            placeholder="全部年级"
          >
            <a-select-option :value="item.id" v-for="(item,index) in gradeList" :key="index">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="3">
          <a-select
            class="select-item"
            v-model="searchParams.subjectId"
            allow-clear
            placeholder="全部科目"
          >
            <a-select-option :value="item.id" v-for="(item,index) in subjectList" :key="index">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="3">
          <a-select
            class="select-item"
            v-model="searchParams.period"
            allow-clear
            placeholder="全部学期"
          >
            <a-select-option :value="item.id" v-for="(item,index) in periodListData" :key="index">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="3">
          <a-select
            class="select-item"
            v-model="searchParams.classStyle"
            allow-clear
            placeholder="全部课程类型"
          >
            <a-select-option :value="item.id" v-for="(item,index) in classStyleList" :key="index">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="4">
          <a-input
            class="select-item"
            v-model="searchParams.itvCourseName"
            allow-clear
            placeholder="请输入学习机课程名称"
          />
        </a-col>
        <a-col :span="4">
          <a-button type="primary" @click="handleSearchBtnClick" style="margin-right: 8px;">
            搜索
          </a-button>
          <a-button @click="handleResetBtnClick">
            重置
          </a-button>
        </a-col>
      </a-row>
      <div v-gdd-hide class="table-top">
        <a-checkbox @change="tryCourseChange" v-model="searchParams.experience">
          只看体验课
        </a-checkbox>
        <div class="right-tip">
          <div class="tip-inner">
            <CardTypes />
            <p><a-icon class="tip-icon" type="exclamation-circle" />&nbsp;仅长线课（非体验课）会使用权益包名额</p>
          </div>
        </div>
      </div>
    </div>
    <div class="result">
      <a-col class="course-list" :span="16">
        <a-table
          class="table"
          ref="table"
          row-key="classTypeId"
          :scroll="scroll"
          :loading="courseTableLoading"
          :columns="columns"
          :data-source="courseList"
          @change="handleTableChange"
          :pagination="false"
          :custom-row="customRow"
          :row-class-name="rowClassName"
        >
          <div slot="itvCourseName" class="course" slot-scope="text, row">
            <span v-show="row.experience === 1" class="try-course">体验课</span>
            <a-tooltip placement="top">
              <template slot="title">
                课程ID: {{ row.classTypeId }}
              </template>
              {{ text }}
            </a-tooltip>
            <TextTagNew v-if="row.sourceType && row.sourceType === 2" class-name="yellow" words="课程升级Pro版" />
          </div>
          <div slot="action" slot-scope="text, record" class="operate">
            <a-button type="primary" @click="resourceClick(record)" ghost>
              课程资料
            </a-button>
          </div>
        </a-table>
        <div class="pagination">
          <a-pagination
            v-if="coursePagination.totalPage > 0"
            v-model="coursePagination.current"
            :total="coursePagination.totalPage"
            :page-size="coursePagination.pageSize"
          />
        </div>
      </a-col>
      <a-col class="group-list" :span="8">
        <header>
          <span class="label">包含小组</span>
          <a-button type="primary" icon="plus" size="small" @click="handleAddGroupBtnClick">
            新建小组
          </a-button>
        </header>
        <div class="list-wrap">
          <div v-if="groupListLoading" class="spin">
            <a-spin />
          </div>
          <div class="list">
            <div v-if="groupList && groupList.length > 0">
              <GroupItem
                v-for="(item, index) in groupList"
                :key="index"
                :item-data="item"
                @hideClick="hideClick"
                @editClick="handleGroupItemEditClick"
              />
            </div>
            <a-empty class="empty" v-else />
          </div>
          <div class="pagination">
            <a-pagination
              v-if="groupPagination.totalPage>groupPagination.pageSize"
              v-model="groupPagination.current"
              :total="groupPagination.totalPage"
              :page-size="groupPagination.pageSize"
            />
          </div>
        </div>
      </a-col>
    </div>
    <GroupManageModal
      v-if="modalVisible"
      :visible.sync="modalVisible"
      :class-type-id="selectedCourseId"
      :course="courseInfo"
      :group-info="selectedGroupItem"
      :course-name="true"
      @onSuccess="handleAddSuccess"
    />
    <CourseResource v-if="resourceVisible" @close="resourceClose" :record="resRecord" />
  </div>
</template>
<script>
import { defineComponent, reactive, ref, unref, computed } from 'vue-demi'
import { useGetCourseList, useGetGroupList, useGetParams } from './hooks'
import GroupManageModal from '../../components/GroupManageModal/index.vue'
import TextTagNew from '@/components/TextTagNew.vue'
import columns from './columns'
// import mixins from '@/utils/mixins'
import GroupItem from './cmps/groupItem'
import courseGroupLogger from '@/utils/logger/courseGroup.js'
import CardTypes from '@/components/CardTypes.vue'
import CourseResource from './cmps/CourseResource'

export default defineComponent({
  name: 'CourseAndGroup',
  components: { GroupManageModal, GroupItem, CardTypes, CourseResource, TextTagNew },

  // mixins: [mixins],
  setup(props, { root, refs }) {
    courseGroupLogger.initPageLogger()
    // 筛选项数据
    const searchParams = reactive({
      gradeId: undefined,
      subjectId: undefined,
      period: undefined,
      classStyle: undefined,
      classTypeName: undefined,
      itvCourseName: undefined,
      // sorter: undefined,
      experience: undefined
    })
    // 选中的课程ID
    const selectedCourseId = ref(-1)
    // 需要编辑的小组
    const selectedGroupItem = ref({})
    // 弹窗状态
    const modalVisible = ref(false)

    // 课程资料弹框
    const resourceVisible = ref(false)
    const resRecord = ref({})

    // 获取列表参数
    const {
      subjectList,
      gradeList,
      periodList: periodListData,
      classStyleList
    } = useGetParams()

    // 左侧课程数据
    const {
      getCourseList,
      courseList,
      courseTableLoading,
      coursePagination,
      scroll
    } = useGetCourseList(searchParams, selectedCourseId, refs)

    // 选中的课程信息
    const courseInfo = computed(() => courseList.value.find(item => item.classTypeId === selectedCourseId.value))

    // 右侧小组数据
    const {
      getGroupList,
      groupList,
      groupListLoading,
      groupPagination
    } = useGetGroupList(selectedCourseId)

    /**
     * @description 自定义table行点击事件
     */
    const customRow = (record, index) => ({
      on: {
        click: () => {
          const { classTypeId } = record
          selectedCourseId.value = classTypeId
        }
      }
    })

    /**
     * @description 选中项的样式
     */
    const rowClassName = (record, index) => {
      const { classTypeId } = record
      return unref(selectedCourseId) === classTypeId ? 'selected-row' : ''
    }

    /**
     * @description 点击新建小组
     */
    const handleAddGroupBtnClick = () => {
      courseGroupLogger.addGroupLogger({ insId: root.$store.state.userInfo.userInfo.institutionId })
      selectedGroupItem.value = {}
      modalVisible.value = true
    }

    /**
     * @description 点击重置
     */
    const handleResetBtnClick = () => {
      Object.keys(searchParams).forEach(item => {
        searchParams[item] = undefined
      })
    }

    /**
     * @description 点击搜索
     */
    const handleSearchBtnClick = () => {
      selectedCourseId.value = -1
      coursePagination.value.current = 1
      getCourseList()
    }

    /**
     * @description 添加成功刷新小组列表
     */
    const handleAddSuccess = () => {
      groupPagination.value.current = 1
      getGroupList()
    }

    /**
     * @description 处理小组编辑事件
     */
    const handleGroupItemEditClick = item => {
      selectedGroupItem.value = item
      modalVisible.value = true
    }
    /**
     * 隐藏小组
     *  */
    const hideClick = () => {
      getGroupList()
    }
    const handleTableChange = (pag, filters, sorter) => {
      // searchParams.sorter = sorter.order // "descend": 降序，"ascend": 升序， undefined: 不排序
      getCourseList()
    }

    const tryCourseChange = e => {
      coursePagination.value.current = 1
      getCourseList()
    }

    /**
     * 课程资料
     */
    const resourceClick = record => {
      console.log(record)
      resRecord.value = record
      resourceVisible.value = true
    }

    const resourceClose = () => {
      resourceVisible.value = false
    }

    return {
      tryCourseChange,
      handleTableChange,
      scroll,
      subjectList,
      gradeList,
      periodListData,
      classStyleList,
      modalVisible,
      selectedCourseId,
      courseTableLoading,
      coursePagination,
      selectedGroupItem,
      customRow,
      columns,
      courseList,
      groupListLoading,
      groupList,
      groupPagination,
      searchParams,
      getCourseList,
      rowClassName,
      handleAddGroupBtnClick,
      handleSearchBtnClick,
      handleResetBtnClick,
      handleAddSuccess,
      handleGroupItemEditClick,
      hideClick,
      courseInfo,
      resourceClick,
      resourceVisible,
      resourceClose,
      resRecord
    }
  }
})
</script>
<style lang="less" scoped>
@import '~@/static/css/base.less';
.ant-table-wrapper {
  :deep(tr) {
    .ant-table-row-cell-break-word {
      position: relative;
      .course {
        height: 100%;
        padding: 14px 4px;
        line-height: 26px;
      }
      .yellow {
        top: 0px;
        right: 15px;
      }
    }
  }
}
.course {
  padding: 11px 8px;
  .try-course {
    position:absolute;
    right: -5px;
    top: 0px;
    font-family: 'Microsoft YaHei UI';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.04em;
    color: #FFFFFF;
    background: #3262FD;
    border-bottom-left-radius: 4px;
    padding: 0 4px;
  }
}
:deep(.selected-row) {
  color: #3262FD;
}
// :deep(.ant-table-wrapper .ant-table .ant-table-tbody>tr>td) {
//   padding-left: 0;
//   padding-right: 16px;
// }
.course-group-page {
  height: 100%;
  padding: 24px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  overflow: scroll;
  .filter {
    .select-item {
      width: 100%;
    }
  }
  .result {
    flex: 1;
    margin-top: 24px;
    overflow: hidden;
    .course-list {
      height: 100%;
      display: flex;
      flex-direction: column;
      padding-right: 12px;
      overflow: hidden;
      .table {
        flex: 1;
        overflow: hidden;
      }
      .pagination {
        text-align: right;
        padding-top: 12px;
      }
    }
    .group-list {
      height: 100%;
      padding: 0 0 0 12px;
      display: flex;
      flex-direction: column;
      border-left: 1px solid #ddd;
      .label {
        font-size: 20px;
        font-weight: bold;
        margin-right: 20px;
        vertical-align: sub;
      }
      .list-wrap {
        display: flex;
        position: relative;
        flex-direction: column;
        height: calc(100% - 30px);
        .spin {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 100;
          display: flex;
          justify-content: center;
          align-items: center;
          background: rgba(0,0,0,0.02);
        }
        .list {
          flex: 1;
          overflow-y: scroll;
          &::-webkit-scrollbar {
              width: 6px;
              height: 6px;
              background-color: #242731;
          }
          &::-webkit-scrollbar-thumb{
              width: 6px;
              height: 6px;
              opacity: 0.8;
              border-radius: 3px;
              background: #C7C7C7;
          }
          &::-webkit-scrollbar-track {
              background: #fff;
          }
          &::-webkit-scrollbar-button {
              background: #fff;
          }
          &::-webkit-scrollbar-corner {
              background: #fff;
          }
          .empty {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
        .pagination {
          text-align: right;
        }
      }
    }
  }
}
.table-top {
  margin-top: 8px;
  position: relative;
  display: flex;
  align-items: center;
}
.right-tip {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.tip-inner {
  display: flex;
  color: #FF8800;
  align-items: center;
  // margin-left: -115px;
  p {
    margin-left: 24px;
  }
}
</style>
